import { RowCrudStatus } from "../../common/types";
import {
  DocumentGenerationParams,
  DocumentGenerationParamsCreateMutationVariables,
  DocumentGenerationParamsUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { graphqlToCalendarDate } from "../../../common/utils";
import { diaDeCalendario } from "../../../common/calendarDate";

export type DocumentGenerationParamsValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  contractEffectiveDate: string | null;
  contractEndDate: string | null;
};

export type DocumentGenerationParamsErrorsType = {
  contractEffectiveDate?: { message: string; fieldLabel: string };
  contractEndDate?: { message: string; fieldLabel: string };
};

export function DocumentGenerationParamsValuesInit(): DocumentGenerationParamsValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    contractEffectiveDate: null,
    contractEndDate: null,
  };
}

export type DocumentGenerationParamsType =
  | DocumentGenerationParams
  | DocumentGenerationParamsValuesType;

export function documentGenerationParamsDisplayId(
  source: Partial<DocumentGenerationParams>,
  _langStore: LangStore
) {
  return source.contractEffectiveDate === null ||
    source.contractEffectiveDate === undefined
    ? _langStore.emptyStringSymbol
    : graphqlToCalendarDate(source.contractEffectiveDate);
}

export function getDocumentGenerationParamsValues(
  source: DocumentGenerationParamsType,
  _langStore: LangStore,
  _duplicated: boolean = false
): DocumentGenerationParamsValuesType {
  const entityValues = DocumentGenerationParamsValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : documentGenerationParamsDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.contractEffectiveDate = diaDeCalendario(
    source.contractEffectiveDate
  );
  entityValues.contractEndDate = diaDeCalendario(source.contractEndDate);
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getDocumentGenerationParamsUpdateVariables(
  values: DocumentGenerationParamsValuesType
): DocumentGenerationParamsUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    contractEffectiveDate: values.contractEffectiveDate!,
    contractEndDate: values.contractEndDate || null,
  };
}

export function getDocumentGenerationParamsCreateVariables(
  values: DocumentGenerationParamsValuesType
): DocumentGenerationParamsCreateMutationVariables {
  return {
    contractEffectiveDate: values.contractEffectiveDate!,
    contractEndDate: values.contractEndDate || null,
  };
}
